import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface FloaterSpreadBpsFieldProps {}

export const FloaterSpreadBpsField: React.FC<FloaterSpreadBpsFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ floater_spread_bps: number }>()

  return (
    <FormField
      name="floater_spread_bps"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Floater Spread (Bps)</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              {...register('floater_spread_bps')}
              placeholder={'Enter the floater spread in bps...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
